// /admin/support — the cross-tenant support inbox.

import { createRoute } from "@tanstack/react-router";
import { adminRoute } from "./_admin";
import { SupportInboxScreen } from "../screens/admin/SupportInboxScreen";

export const adminSupportRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/admin/support",
  staticData: { title: "Support inbox" },
  component: SupportInboxScreen,
});
